import Vue from 'vue'
import Component from 'vue-class-component'
import authStore from '@/store/auth/auth-store'

@Component({
  name: 'non-auth-header'
})
export default class NonAuthHeader extends Vue {

  public login (): void {
    authStore.dispatchLogin()
  }
}
